// extracted by mini-css-extract-plugin
export default {"container":"ConfigBar_container__HE6q+","modified":"ConfigBar_modified__GGoWa","missedColumns":"ConfigBar_missedColumns__zPp2T"};